import type { WithAuthComponentProps } from '@/_hocs/with-auth'
import { WithAuth } from '@/_hocs/with-auth'
import { guarantorColumns } from '@/features/_columns/guarantor-table-column'
import { LoadingDataTable } from '@/features/_components/loading-data-table'
import { Container } from '@/features/_components/ui/container'
import { useApplicationParams } from '@/features/_hooks/use-application-params'
import { queries } from '@/features/_lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { PersonHeader } from '../_components/person-header'
import { PersonHeaderSkeleton } from '../_components/person-header.skeleton'
import { CreateGuarantorButton } from '../guarantors/_components/create-guarantor-button'
import { GuarantorsTable } from './_components/guarantors-table'

const Guarantors = ({ session }: WithAuthComponentProps) => {
  const { companyId, facilityId, companySlug, facilitySlug, applicationId } = useApplicationParams()

  const { data, isLoading } = useQuery({
    ...queries.applications.detailFull(companyId, facilityId, applicationId),
    enabled: !!companyId && !!facilityId,
  })

  if (isLoading || !data)
    return (
      <Container className="h-full px-14 py-10 gap-6">
        <PersonHeaderSkeleton />
        <LoadingDataTable columns={guarantorColumns} />
      </Container>
    )

  const { application, facility } = data

  return (
    <Container className="h-full px-14 py-10 gap-6">
      <PersonHeader
        application={application}
        person={application.person}
        facility={facility}
        userType={session.user.userType}
      />

      <div className="flex w-full items-center justify-between">
        <h2 className="text-xl font-semibold text-brand-grayscale-12">Avalistas</h2>
        <CreateGuarantorButton />
      </div>

      <GuarantorsTable
        applicationId={applicationId}
        companySlug={companySlug}
        facilitySlug={facilitySlug}
        guarantors={application.guarantors}
      />
    </Container>
  )
}

export default WithAuth(Guarantors, { allowedFor: ['staff', 'tenant'] })
